var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardEquipe"},[_c('div',{staticClass:"image",style:({ 'background-image': 'url(' + _vm.imgagemPadrao + ')' })}),_c('div',{staticClass:"info"},[_c('p',[_vm._v(_vm._s(_vm.nome))])])])}
var staticRenderFns = []

export { render, staticRenderFns }